var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AchooBarChartComponent } from '../../../../core/achoo-bar-chart/achoo-bar-chart.component';
import { UserService } from '../../../../services/user.service';
import { CommonConstant } from '../../../../app.constants';
var DemographicBarChartComponent = /** @class */ (function (_super) {
    __extends(DemographicBarChartComponent, _super);
    function DemographicBarChartComponent(userService) {
        return _super.call(this, userService) || this;
    }
    DemographicBarChartComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.progressHeight = CommonConstant.DEMOGRAPHIC_BAR_CHART_PROGRESS_HEIGHT;
        this.borderRadius = CommonConstant.DEMOGRAPHIC_BAR_CHART_BORDER_RADIUS;
        while (this.series.length < this.maxLine) {
            this.series.push({
                title: null,
                value: 0,
                formattedValue: '-'
            });
        }
    };
    DemographicBarChartComponent.prototype.calculateProgressBar = function (value) {
        if (this.maxValue) {
            return Math.round((value / this.maxValue) * 100);
        }
        return _super.prototype.calculateProgress.call(this, value);
    };
    return DemographicBarChartComponent;
}(AchooBarChartComponent));
export { DemographicBarChartComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/new-influencer-demographic/demographic-bar-chart/demographic-bar-chart.component.ts.pre-build-optimizer.js